import React, { useEffect } from 'react';
import { ToastProvider as TamaguiToastProvider, ToastViewport, useToastController } from '@tamagui/toast';
import { CustomToast, setToastController } from '@/utils/toast';

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <TamaguiToastProvider swipeDirection="down" duration={3000} native={false}>
      <ToastControllerInitializer />
      {children}
      <CustomToast />
      <ToastViewport 
        name="main" 
        bottom="$4" 
        left={0} 
        right={0} 
        alignItems="center"
        zIndex={999999}
      />
    </TamaguiToastProvider>
  );
};

const ToastControllerInitializer: React.FC = () => {
  const toastController = useToastController();

  useEffect(() => {
    setToastController(toastController);
  }, [toastController]);

  return null;
};

